import * as Sentry from "@sentry/react";
import { CaptureContext } from "@sentry/types/types/scope";
import { isDev, isLocal, isProd } from "../config/env";

export const useLogger = () => {
  const logger = {
    log: (message: string, extra?: CaptureContext) => {
      if (!isProd) {
        // Don't log console to prod since we have sentry integration with console which will double log to Sentry
        console.log(message, extra ?? "");
      }

      if (!isLocal || !isDev) {
        Sentry.captureMessage(message, extra);
      }
    },
    error: (message: string, extra?: CaptureContext) => {
      if (!isProd) {
        // Don't log console to prod since we have sentry integration with console which will double log to Sentry
        console.error(message, extra);
      }
      if (!isLocal || !isDev) {
        Sentry.captureException(message, extra);
      }
    },
  };
  return { logger };
};
